module.exports = __webpack_public_path__ + "static/media/PartnersBanner.c095e66d.png";